export default "__VITE_ASSET__BwKWbgOu__"